// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "client-viewer/" + (chunkId === 732 ? "wix-payment-methods-banner-demo" : chunkId) + ".chunk.min.js";
};